var map = {
	"./bronze.svg": 67,
	"./coder.svg": 53,
	"./edit.svg": 54,
	"./gold.svg": 68,
	"./good.svg": 69,
	"./show.svg": 55,
	"./silver.svg": 70,
	"./upload.svg": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66;